module.exports = __webpack_public_path__ + "img/444.2879b4d2.png";